exports = module.exports = require("../../../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".eyajVRB0PbiK5qhkEFj3M{position:absolute;left:-999em}", ""]);
// Exports
exports.locals = {
	"monaco-aria-container": "eyajVRB0PbiK5qhkEFj3M"
};